import { Flex, Select } from '@approvalmax/ui/src/components';
import { memo, useCallback } from 'react';

import { FilterReferenceValueProps } from './FilterReferenceValue.types';

export const FilterReferenceValue = memo<FilterReferenceValueProps>((props) => {
    const { options, filter, onFilterChange } = props;

    const handleChange = useCallback(
        (valueId: string) => {
            const value = options.find((option) => option.id === valueId) || options[0];

            if (value) {
                onFilterChange({ ...filter, value });
            }
        },
        [filter, onFilterChange, options]
    );

    return (
        <Flex width={167}>
            <Select
                value={filter.value?.id}
                size='small'
                itemIdKey='id'
                itemNameKey='text'
                items={options}
                clearable={false}
                onChange={handleChange}
                autocomplete
            />
        </Flex>
    );
});

FilterReferenceValue.displayName = 'FilterReferenceValue';
